require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./article-webmd-symptoms.json") })
        }
      }, "path---article-webmd-symptoms");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---article-webmd-symptoms!./.cache/json/article-webmd-symptoms.json
// module id = 374
// module chunks = 231608221292675